import { useCallback } from "react";

import { Modal } from "@icg360/design-system";

import { printWDUserAgreement } from "./print-helpers";
import styles from "./waiver-terms.module.scss";

export const WaiverTermsModal = ({ header, content, show, onClose }) => {
  const printUserAgreement = useCallback(() => {
    if (!content) return;
    printWDUserAgreement(header, content);
  }, [header, content]);

  return (
    <Modal
      open={show}
      onClose={onClose}
      heading={header}
      primaryAction="Close"
      onPrimaryAction={onClose}
      tertiaryAction="Print"
      onTertiaryAction={printUserAgreement}
      size="lg"
    >
      <div className={styles.participationAgreementContent}>
        {content
          ?.split("\n")
          ?.map((paragraph, i) => <p key={i}>{paragraph}</p>) ?? ""}
      </div>
    </Modal>
  );
};
